/**
 * Fragment de routes du paquet v7-p01-projets-ecrans (vague V7, règle R2 du découpage V4–V11 : un fragment par paquet).
 * Composants chargés à la demande (règle de chargement du registre), aucun code exécuté au chargement.
 * Routes du socle remplacées (`remplace: true`), d'après les `couvre: route:` des YAML : `/programme/projets`
 * (programme-projets) et `/programme/reglages` (programme-reglages) ; les écrans historiques
 * `screens/niveaux/programme/ProjetsProgramme` et `ReglagesProgramme` ne sont plus servis (fichiers et App.tsx, gelé,
 * inchangés). Routes neuves (programme par `?programme=`, sinon celui de la coquille) :
 *  - `/programme/projets/nouveau` (dialogue-creer-projet-programme) ; `/programme/projets/rattacher`
 *    (dialogue-rattacher-projet-au-programme) ;
 *  - `/programme/reglages/configuration` (programme-configuration) ; `/programme/reglages/cycle-de-vie`
 *    (programme-cycle-de-vie) ; `/programme/reglages/cycle-de-vie/suppression` (dialogue-supprimer-programme).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProgrammeProjets = lazy(() => import('../ecrans/v7/projets/ProgrammeProjets'))
const DialogueCreerProjetProgramme = lazy(() => import('../ecrans/v7/projets/DialogueCreerProjetProgramme'))
const DialogueRattacherProjetAuProgramme = lazy(() => import('../ecrans/v7/projets/DialogueRattacherProjetAuProgramme'))
const ProgrammeReglages = lazy(() => import('../ecrans/v7/projets/ProgrammeReglages'))
const ProgrammeConfiguration = lazy(() => import('../ecrans/v7/projets/ProgrammeConfiguration'))
const ProgrammeCycleDeVie = lazy(() => import('../ecrans/v7/projets/ProgrammeCycleDeVie'))
const DialogueSupprimerProgramme = lazy(() => import('../ecrans/v7/projets/DialogueSupprimerProgramme'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v7-projets',
  routes: [
    { chemin: '/programme/projets', element: ecran(ProgrammeProjets), remplace: true },
    { chemin: '/programme/projets/nouveau', element: ecran(DialogueCreerProjetProgramme) },
    { chemin: '/programme/projets/rattacher', element: ecran(DialogueRattacherProjetAuProgramme) },
    { chemin: '/programme/reglages', element: ecran(ProgrammeReglages), remplace: true },
    { chemin: '/programme/reglages/configuration', element: ecran(ProgrammeConfiguration) },
    { chemin: '/programme/reglages/cycle-de-vie', element: ecran(ProgrammeCycleDeVie) },
    { chemin: '/programme/reglages/cycle-de-vie/suppression', element: ecran(DialogueSupprimerProgramme) },
  ],
}
